import { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { RESOURCES } from "../data/site";

export default function Article() {
  const { slug } = useParams();
  const article = RESOURCES.find((r) => r.slug === slug);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (article) document.title = `${article.title} | Mobile Maintenance`;
  }, [article]);

  if (!article) {
    return (
      <>
        <Navbar />
        <main className="bg-mm-base pt-40 pb-32 min-h-screen text-center px-5">
          <h1 className="font-heading font-black uppercase text-5xl text-white">Article Not Found</h1>
          <Link to="/resources" className="mt-8 inline-block text-mm-green font-mono uppercase tracking-widest">Back to Resources</Link>
        </main>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Navbar />
      <main className="bg-mm-base pt-32 pb-24 min-h-screen">
        <article className="mx-auto max-w-3xl px-5 sm:px-8">
          <Link to="/resources" className="inline-flex items-center gap-2 text-gray-400 hover:text-mm-green transition-colors font-mono text-xs uppercase tracking-widest mb-10" data-testid="back-resources">
            <ArrowLeft size={14} /> All Resources
          </Link>
          <div className="flex items-center gap-4 font-mono text-[11px] uppercase tracking-widest text-mm-green">
            <span>{article.category}</span><span className="text-gray-600">•</span>
            <span className="text-gray-500">{article.read}</span><span className="text-gray-600">•</span>
            <span className="text-gray-500">{article.date}</span>
          </div>
          <h1 className="mt-5 font-heading font-black uppercase tracking-tight text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.92]">
            {article.title}
          </h1>
          <div className="mt-10 space-y-6">
            {article.body.map((p, i) => (
              <p key={`${article.slug}-${i}`} className="text-gray-300 text-lg leading-relaxed">{p}</p>
            ))}
          </div>

          <div className="mt-16 beam p-8 relative">
            <div className="relative z-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
              <div>
                <h3 className="font-heading font-bold uppercase text-2xl text-white">Ready to protect your fleet?</h3>
                <p className="mt-1 text-gray-400">Request priority service, 24/7/365.</p>
              </div>
              <Link to="/#request" className="shrink-0 inline-flex items-center gap-2 font-heading font-bold uppercase tracking-wider bg-mm-green text-black px-6 py-3.5 hover:bg-white transition-colors">
                Get A Quote <ArrowRight size={18} />
              </Link>
            </div>
          </div>
        </article>
      </main>
      <Footer />
    </>
  );
}
